var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditiconbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4834 10.0603L13.4892 7.29863L14.4755 6.37808C14.7456 6.12603 15.0774 6 15.471 6C15.8646 6 16.1962 6.12603 16.4658 6.37808L17.4521 7.29863C17.7221 7.55068 17.863 7.8549 17.8748 8.21129C17.8865 8.56767 17.7573 8.87167 17.4873 9.12329L16.4834 10.0603ZM15.4618 11.0301L7.99413 18H5V15.2055L12.4677 8.23562L15.4618 11.0301Z",
    fill: "#901F5D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditiconbutton);
export default __webpack_public_path__ + "static/media/edit icon button.152b75d4.svg";
export { ForwardRef as ReactComponent };